import React from 'react';
import { Icon } from '../Icon';
import styles from './PauseSlideContentV24.css';

function PauseSlideContentV24() {
    return (
        <section className={styles.form}>
            <div className={styles.card}>
                <div className={styles.people} aria-hidden='true'>
                    {Array.from({ length: 33 }, (_, index) => (
                        <Icon key={index} name='person' className={styles.person} />
                    ))}
                </div>
                <p className={styles.stat}>53%</p>
                <p className={styles.statText}>of Americans can’t name all four of their grandparents.</p>
                <p className={styles.source}>Ancestry / OnePoll, 2022, 2,113 U.S. adults</p>
            </div>
            <h2 className={styles.heading}>The stories only you can tell</h2>
            <div className={styles.description}>
                <p>One day, your family will want to know where they come from.</p>
                <p>Your digital book <strong>keeps those stories,</strong> with photos. And <strong>it keeps growing:</strong> add new ones anytime, for years.</p>
            </div>
        </section>
    );
}

export {
    PauseSlideContentV24
};
